<template>
        <div class="propetyBlock">
           <h4 class="header" contenteditable="true" @blur="handleHeader">{{header}}</h4>
            <p class="block" contenteditable="true" @blur="handleInput" v-text="inputText"></p>  
            <!-- < v-model="message" placeholder="add multiple lines"></textarea> -->
        </div>
</template>

<script>

export default {
    name: 'propetyBlock',
    props: {
        header:String,
        text: String,
        // inputText:String
    },
    data:function(){
        return {
            inputText: this.text,
            inputHeader: this.header,
        }
    },
    methods:{
        handleInput:function(e){
            this.inputText = e.target.innerText;
        },
        handleHeader:function(e){
            this.inputHeader= e.target.innerText;
        }
    },
}
</script>

<style>
  .propertyBlock {
    margin-top: 0.3em;
    margin-bottom: 0.9em;
    line-height: 1.5;
    display: inline-block;
  }

  h4.header{
    margin: 0;
    display: inline;
    font-weight: bold;
    font-style: italic;
    font-size: 1em !important;
  }

  p:first-of-type{
    display: inline;
    text-indent: 0;
  }

  p{
    text-indent: 1em;
    margin: 0;
  }

  .block:hover{
    background-color: white;
  }
  .block:focus{
    background-color: white;
    outline-width: 0.5px !important;
    outline-color: rgb(99, 99, 99) !important;
  }
</style>